package com.example.borshi.web.components

import androidx.compose.runtime.Composable
import com.example.borshi.web.Screen
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Text

@Composable
fun BottomNavigation(currentScreen: Screen, onNavigate: (Screen) -> Unit) {
    // Bottom navigation for mobile only (CSS handles visibility)
    Div({
        classes("bottom-nav")
    }) {
        // Home
        BottomNavItem(
            icon = "🏠",
            label = "Home",
            isActive = currentScreen is Screen.Home,
            onClick = { onNavigate(Screen.Home) }
        )

        // Plans
        BottomNavItem(
            icon = "💪",
            label = "Plans",
            isActive = currentScreen is Screen.ProteinPlans,
            onClick = { onNavigate(Screen.ProteinPlans) }
        )

        // Products
        BottomNavItem(
            icon = "🛒",
            label = "Shop",
            isActive = currentScreen is Screen.Products,
            onClick = { onNavigate(Screen.Products()) }
        )

        // Account
        BottomNavItem(
            icon = "👤",
            label = "Profile",
            isActive = currentScreen is Screen.Account,
            onClick = { onNavigate(Screen.Account) }
        )
    }
}

@Composable
fun BottomNavItem(
    icon: String,
    label: String,
    isActive: Boolean,
    onClick: () -> Unit
) {
    Div({
        classes("bottom-nav-item")
        if (isActive) {
            classes("active")
        }
        onClick { onClick() }
    }) {
        Div({ classes("icon") }) {
            Text(icon)
        }
        Div({ classes("label") }) {
            Text(label)
        }
    }
}
